import { DefaultCustomRatePayload } from '../store/_declarations/financialCalculator';

export const isVatInluded = (
  vehicle?: DefaultCustomRatePayload.Vehicle,
  client?: DefaultCustomRatePayload.Customer,
  market?: string
) => {
  if (!market || !vehicle || !client) return false;
  switch (market.toUpperCase()) {
    case 'IT':
    case 'UK':
      return client.clientType === 'P';
    case 'FR':
      return vehicle.features?.kind === 'VP';
    default:
      return false;
  }
};

export const thousandsSeparator = (market?: string) => {
  switch (market?.toUpperCase()) {
    case 'UK':
      return ',';
    case 'IT':
      return '.';
    default:
      return '.';
  }
};

export const decimalsSeparator = (market?: string) => {
  switch (market?.toUpperCase()) {
    case 'UK':
      return '.';
    case 'IT':
      return ',';
    default:
      return ',';
  }
};
